import { returnRetrievalRankingDebugInfo } from "@faire/retailer-shared/search/loggedInBrandLeanProductTilesRequest";
import { buildSearchProductsRequest } from "@faire/retailer-shared/search/searchRequest";
import { PAGE_SIZE } from "@faire/retailer-shared/search/searchRequest";
import { getSettingShouldDisplayRetrievalAndRankingDebugInfo } from "@faire/retailer-visitor-shared/settings/getSettingShouldDisplayRetrievalAndRankingDebugInfo";
import { useProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { useSearchPageFiltersQueryQueryKey, useSearchPageQueryQueryKey } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryKey";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageParsedSearch } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageParsedSearch";
import { FilterSplitStrategy } from "@faire/web-api--source/indigofair/data/FilterSplitStrategy";
import { useMemo } from "react";
var STALE_TIME_MS = 5 * 60 * 1000;
export var useSearchPageQueryArgs = function() {
    var pageSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PAGE_SIZE, pageNumber = arguments.length > 1 ? arguments[1] : void 0;
    var productsQueryKey = useSearchPageQueryQueryKey(pageNumber);
    var queryProducts = useProductCacheStore([
        "queryProducts"
    ]).queryProducts;
    var parsedSearch = useSearchPageParsedSearch();
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    var productsRequest = buildSearchProductsRequest({
        filterSplitStrategy: FilterSplitStrategy.PRODUCTS_ONLY,
        parsedSearch: parsedSearch,
        pageSize: pageSize,
        pageNumber: pageNumber,
        shouldRequestRetrievalRankingDebugInfo: returnRetrievalRankingDebugInfo(UserStore.get().user, getSettingShouldDisplayRetrievalAndRankingDebugInfo()),
        isDiscoverV3Search: isFromDiscoverURL
    });
    return useMemo(function() {
        return {
            productsQueryArgs: {
                key: productsQueryKey,
                fn: function(param) {
                    var signal = param.signal;
                    return queryProducts(productsRequest, signal);
                },
                staleTime: STALE_TIME_MS
            }
        };
    }, [
        productsQueryKey,
        productsRequest,
        queryProducts
    ]);
};
export var useSearchPageFiltersQueryArgs = function() {
    var filtersQueryKey = useSearchPageFiltersQueryQueryKey();
    var queryFilters = useProductCacheStore([
        "queryFilters"
    ]).queryFilters;
    var parsedSearch = useSearchPageParsedSearch();
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    var filtersRequest = buildSearchProductsRequest({
        filterSplitStrategy: FilterSplitStrategy.AGGREGATIONS_ONLY,
        parsedSearch: parsedSearch,
        shouldRequestRetrievalRankingDebugInfo: false,
        isDiscoverV3Search: isFromDiscoverURL
    });
    return useMemo(function() {
        return {
            filtersQueryArgs: {
                key: filtersQueryKey,
                fn: function(param) {
                    var signal = param.signal;
                    return queryFilters(filtersRequest, signal);
                },
                staleTime: STALE_TIME_MS
            }
        };
    }, [
        filtersQueryKey,
        filtersRequest,
        queryFilters
    ]);
};
